module.exports = __webpack_public_path__ + "static/media/logo-atulaya.42c563e5.svg";